import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../translations';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { lang, setLang } = useLanguage();

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <header className="header">
      <div className="header-inner">
        <nav>
          <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            <span></span>
            <span></span>
            <span></span>
          </button>
          <ul className={menuOpen ? 'open' : ''}>
            <li><Link to="/" className={isActive('/')} onClick={() => setMenuOpen(false)}>{t(lang, 'nav_home')}</Link></li>
            <li><Link to="/about" className={isActive('/about')} onClick={() => setMenuOpen(false)}>{t(lang, 'nav_about')}</Link></li>
            <li><Link to="/presentations" className={isActive('/presentations')} onClick={() => setMenuOpen(false)}>{t(lang, 'nav_whitepapers')}</Link></li>
            <li><Link to="/contact" className={isActive('/contact')} onClick={() => setMenuOpen(false)}>{t(lang, 'nav_contact')}</Link></li>
            <li><Link to="/impressum" className={isActive('/impressum')} onClick={() => setMenuOpen(false)}>{t(lang, 'nav_impressum')}</Link></li>
          </ul>
        </nav>

        <div className="header-right">
          <div className="lang-switcher">
            <button
              className={`lang-btn ${lang === 'de' ? 'active' : ''}`}
              onClick={() => setLang('de')}
              title="Deutsch"
            >
              <svg viewBox="0 0 640 480" className="flag-icon">
                <rect width="640" height="160" fill="#000"/>
                <rect y="160" width="640" height="160" fill="#D00"/>
                <rect y="320" width="640" height="160" fill="#FFCE00"/>
              </svg>
            </button>
            <button
              className={`lang-btn ${lang === 'en' ? 'active' : ''}`}
              onClick={() => setLang('en')}
              title="English"
            >
              <svg viewBox="0 0 640 480" className="flag-icon">
                <rect width="640" height="480" fill="#012169"/>
                <path d="M75 0l244 181L562 0h78v62L400 241l240 178v61h-80L320 302 82 480H0v-60l239-178L0 64V0h75z" fill="#fff"/>
                <path d="M424 281l216 159v40L369 281h55zm-184 20l6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z" fill="#C8102E"/>
                <path d="M241 0v480h160V0H241zM0 160v160h640V160H0z" fill="#fff"/>
                <path d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z" fill="#C8102E"/>
              </svg>
            </button>
          </div>

          <Link to="/" className="logo" onClick={() => setMenuOpen(false)}>
            <img src="/rds-logo.png" alt="Red-Database-Security" className="logo-img" />
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
